import env from '../env';
import { globalObject } from '../system';
import util from '../util';
import config from './config';
import { openMiddlePage } from './utils/helpers';

let callbacks = [];
let loadScript = false;
const isInQnReadingApp = globalObject.navigator ? globalObject.navigator.userAgent.indexOf('qnreading') >= 0 : false;

function readyCallback() {
  window.TencentNews = window.TencentNews || window.TencentReading;
  for (const func of callbacks) {
    func();
  }
  callbacks = [];
}

function newsApiReady(func) {
  if (window.TencentNews || window.TencentReading) {
    window.TencentNews = window.TencentNews || window.TencentReading;
    func();
  } else {
    if (env.isAndroid && !loadScript) {
      util.loadScript(
        'news_script',
        env.isAndroid && isInQnReadingApp
          ? '//mat1.gtimg.com/www/reading/android/js/jsapi/jsapi.js'
          : '//mat1.gtimg.com/www/js/newsapp/jsapi/news.js?_tsid=1',
        () => {
          readyCallback();
        },
      );
      loadScript = true;
    } else if (env.isIos || env.isIpad) {
      if (!window._TencentNewsReady_) {
        window._TencentNewsReady_ = readyCallback;
      }
    }
    callbacks.push(func);
  }
}

export const canGetInstallState = true;

export function ready() {
  return new Promise((resolve) => {
    newsApiReady(resolve);
  });
}

export function getInstallState(conf = config) {
  return new Promise((resolve) => {
    newsApiReady(() => {
      if (env.isIos) {
        TencentNews.checkCanOpenNativeUrl(conf.packageUrl, (
          url,
          result,
        ) => {
          resolve(result);
        });
      } else if (env.isAndroid) {
        const { packageName } = conf;
        window.checkCanOpenNativeUrlCallBack = function (result) {
          resolve(result);
        };
        if (isInQnReadingApp) {
          TencentNews.checkCanOpenNativeUrl(
            packageName,
            'checkCanOpenNativeUrlCallBack',
            null,
          );
        } else {
          TencentNews.checkCanOpenNativeUrl(
            packageName,
            'checkCanOpenNativeUrlCallBack',
          );
        }
      }
    });
  });
}

export async function launch(schemeUrl, conf = config) {
  if (env.isIos) {
    TencentNews.openNativeUrl(schemeUrl, () => {}, null);
  } else if (env.isAndroid) {
    TencentNews.openApp(schemeUrl, conf.packageName);
  }
  return true;
}

export async function download(conf = config) {
  const isOpenAppPage = openMiddlePage();
  // 只有 openapp 中间页才拉起下载
  if (!isOpenAppPage) return;

  if (env.isIos) {
    TencentNews.openNativeUrl(conf.download, () => {}, null);
  } else if (env.isAndroid) {
    TencentNews.downloadApp(conf.download, conf.packageName, '应用下载');
    TencentNews.showTextTips('开始下载APP！');
  }
}

export default {
  canGetInstallState,
  ready,
  getInstallState,
  launch,
  download,
};
